import script from "./corporate-title.vue?vue&type=script&lang=js"
export * from "./corporate-title.vue?vue&type=script&lang=js"

import "./corporate-title.vue?vue&type=style&index=0&id=9c13fbee&lang=scss"

const __exports__ = script;

export default __exports__